import BaseHero from './Hero';

// EXPORT
export const Hero = BaseHero;
export type { HeroProps } from './Hero.interface';
